import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import {
    Container,
    Row,
    Col,
    // Button,
    Card,
    CardBody,
    Input,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from "reactstrap"

import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { TreeSelect } from "primereact/treeselect";
import { Checkbox } from "primereact/checkbox";
import { Editor } from "primereact/editor";
import { MultiSelect } from "primereact/multiselect";
import Select from 'react-select';
import { Toast } from 'primereact/toast';
import { Link, useNavigate } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";
import { FileUpload } from "primereact/fileupload";
import axios from "axios"
import { getCookie } from "../../helpers/cookie"
import { Button } from 'primereact/button';
//i18n

const ContactEditForm = () => {
    const navigate = useNavigate();

    // contact edit form starts

    const [fullname, setFullname] = useState();
    const [email, setEmail] = useState();
    const [phno, setPhno] = useState();
    
    const [designation, setDesignation] = useState(["UI/UX Manager"]);
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const [selectedCompany, setSelectedCompany] = useState(null);
    const fileUploadRef = useRef(null);
    
    const [selectedDesignation1, setSelectedDesignation1] = useState(null);
    const [designationOptions, setDesignationOptions] = useState([])
    const Token = getCookie("access_token");
    const [companyOptions, setCompanyOptions] = useState([]);
    const [createdBy, setCreatedBy] = useState(null)
    const [CreatedAt, setCreatedAt] = useState(null)
    const [editedBy, setEditedBy] = useState(null)
    const [UpdatedAt, setUpdatedAt] = useState(null)
    const [personOptions, setPersonOptions] = useState([]);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [categoryOptions, setCategoryOptions] = useState([])
    const [selectedCategory1, setSelectedCategory1] = useState(null);
    const [groupOptions, setGroupOptions] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [privateDrop, setPrivateDrop] = useState(false);
    const [PrivetDropdown, setPrivetDropdown] = useState([]);
    const [selectedGroup1, setSelectedGroup1] = useState(null);
    // Lookup modal state for Add/Edit sentinels
    const [lookupModalVisible, setLookupModalVisible] = useState(false)
    const [lookupModalContext, setLookupModalContext] = useState('') // 'designation' | 'department' | 'category' | 'group'
    const [lookupFormValue, setLookupFormValue] = useState('')
    const [editingLookup, setEditingLookup] = useState(false)
    const [lastSelectedLookupId, setLastSelectedLookupId] = useState(null)
    const [lookupDescription, setLookupDescription] = useState('')
    const [selectedEditdrop, setSelectedEditdrop] = useState(null)
    const [selecteddropoptions, setselecteddropoptions] = useState([])
    const lookupAddSentinel = { value: 'add', label: 'Add New', icon: 'pi pi-plus' }
    const lookupEditSentinel = { value: 'edit', label: 'Edit Selected', icon: 'pi pi-pencil' }
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [subject, setSubject] = useState('');
    const [displayDialog, setDisplayDialog] = useState(false);
    const [documents, setDocuments] = useState([]);
    const getDesignationOptions = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_designation`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.data) {
                let results = response.data.results.results;
                console.log(response, 'response');
                const options = results.map((category) => ({
                    label: category.value
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    value: category.id,
                }));
                setDesignationOptions([...options, lookupAddSentinel, lookupEditSentinel]);
            }
        } catch (error) {

        }
    };
    // helper to get label from option arrays (handles different shapes)
    const getOptionLabel = (options, val) => {
        if (!options || val == null) return ''
        const found = options.find(o => o.value === val || o.code === val || o.id === val)
        if (!found) return ''
        return found.label || found.name || found.value || String(found.code || found.id || '')
    }

    // Save (POST or PATCH) for the shared lookup modal
    const handleLookupSave = async () => {
        const lookupNameMap = {
            designation: 'contact_designation',
            group: 'contact_groups',
            department: 'contact_department',
            category: 'employee_department'
        }
        const lookupName = lookupNameMap[lookupModalContext]
        if (!lookupName) return
        try {
            if (!lookupFormValue || lookupFormValue.trim() === '') {
                toast.current && toast.current.show({ severity: 'error', summary: 'Error', detail: 'value is required' })
                return
            }
            if (editingLookup && lastSelectedLookupId) {
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedLookupId}/`, {
                    name: lookupName,
                    value: lookupFormValue,
                    description: lookupDescription || lookupFormValue,
                }, { headers: { Authorization: `Bearer ${Token}` } })
            } else {
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, {
                    name: lookupName,
                    value: lookupFormValue,
                    description: lookupDescription || lookupFormValue,
                    type: 'company'
                }, { headers: { Authorization: `Bearer ${Token}` } })
            }

            // refresh lists
            if (lookupModalContext === 'designation') await getDesignationOptions()
            if (lookupModalContext === 'group') await getGroupOptions()
            if (lookupModalContext === 'department') await getDepartmentOptions()
            if (lookupModalContext === 'category') await getCategoryOptions()

            setLookupModalVisible(false)
            setLookupFormValue('')
            setLookupDescription('')
            setEditingLookup(false)
            setLastSelectedLookupId(null)
            toast.current && toast.current.show({ severity: 'success', summary: 'Saved', detail: 'Lookup saved' })
        } catch (err) {
            console.error('Lookup save failed', err)
            toast.current && toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to save lookup' })
        }
    }
    const getCompanydata = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/companies/`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.data) {
                let results = response.data.results;
                const options = results.map((category) => ({
                    name: category.name
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    code: category.id,
                }));
                setCompanyOptions(options);
            }
        } catch (error) {

        }
    };
    const getDepartmentOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_department`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.data) {
                let results = response.data.results.results;
                console.log(response, 'response');
                const options = results.map((category) => ({
                    name:
                        category.value === category.value.toUpperCase()
                            ? category.value // keep original if already all caps
                            : category.value
                                .replace(/_/g, ' ')
                                .replace(/\b\w/g, (char) => char.toUpperCase()),

                    code: category.id,
                }));
                setDepartmentOptions([...options, lookupAddSentinel, lookupEditSentinel]);
            }
        } catch (error) {

        }
    };
    const getallactivecontacts = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/contacts/`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.data) {
                const options = response.data.results.map((category) => ({
                    name: category.first_name + ' ' + category.last_name
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    code: category.id,
                    role: category.email
                }));
                setPersonOptions(options);
            }
        } catch (error) {

        }
    };
    const getCategoryOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=employee_department`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.data) {
                let results = response.data.results.results;
                console.log(response, 'response');
                const options = results.map((category) => ({
                    label: category.value
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()), // transform here
                    value: category.id,
                }));
                setCategoryOptions([...options, lookupAddSentinel, lookupEditSentinel]);
            }
        } catch (error) {

        }
    };
    const getGroupOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_groups`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.data) {
                let results = response.data.results.results;
                const options = results.map((group) => ({
                    label: group.value
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    value: group.id,
                }));
                setGroupOptions([...options, lookupAddSentinel, lookupEditSentinel]);
            }
        } catch (error) {
            console.error("Error fetching group options:", error);
        }
    };
    const [PrivetDropdownValues, setPrivetDropdownValues] = useState(null)
    const getPrivateOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.data) {
                let results = response.data.data;
                console.log(results, 'results');
                const options = results.map((category) => ({
                    name: category.name
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    value: category.id,
                    email: category.email
                }));
                setPrivetDropdownValues(options);
            }
        } catch (error) {

        }
    };
    const getData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/contacts/?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            if (response.status === 200) {
                console.log(response.data.results[0], "Contact data fetched successfully:");
                setFullname(`${response.data.results[0].first_name} ${response.data.results[0].last_name}`);
                setEmail(response.data.results[0].email);
                setPhno(response.data.results[0].phone);
                setSelectedDesignation1(response.data.results[0].designation);
                setSelectedCompany(response.data.results[0].company);
                setCreatedBy(response.data.results[0].created_by_name);
                setCreatedAt(new Date(response.data.results[0].created_at));
                setEditedBy(response.data.results[0].updated_by_name);
                setUpdatedAt(new Date(response.data.results[0].updated_at));
                setSelectedPerson(response.data.results[0].reporting_person);
                // setSelectedPerson(response.data.results[0].reporting_person_name);
                setSelectedCategory1(response.data.results[0].categories[0]);
                setPrivateDrop(response.data.results[0].is_private);
                setSelectedGroup1(response.data.results[0].groups[0]);
                setSelectedDepartment(response.data.results[0].department);
                setPrivetDropdown(response.data.results[0].private_users);
                const addressFromAPI = response.data.results[0].address || '';
                setAddress(addressFromAPI.replace(/,\s*/g, '\n'));
            }

        } catch (error) {
            console.error("Error fetching contact data:", error);
        }
    };
    useEffect(() => {
        getData();
        getDesignationOptions();
        getCompanydata();
        getDepartmentOptions();
        getallactivecontacts();
        getCategoryOptions();
        getGroupOptions();
        getPrivateOptions();
    }, [id]);

    // populate the edit-select dropdown options based on which lookup is being edited
    useEffect(() => {
        const normalize = (arr) => (arr || []).
            // remove sentinel entries (value 'add' or 'edit') before mapping
            filter(o => !(o && (o.value === 'add' || o.value === 'edit' || o.label === 'Add New' || o.label === 'Edit Selected')))
            .map((o) => ({
                id: o.id ?? o.code ?? o.value,
                name: o.name ?? o.label ?? o.value ?? String(o.code ?? o.id ?? ''),
                raw: o,
            }))

        if (lookupModalContext === 'designation') {
            setselecteddropoptions(normalize(designationOptions))
            return
        }
        if (lookupModalContext === 'department') {
            setselecteddropoptions(normalize(departmentOptions))
            return
        }
        if (lookupModalContext === 'category') {
            setselecteddropoptions(normalize(categoryOptions))
            return
        }
        if (lookupModalContext === 'group') {
            setselecteddropoptions(normalize(groupOptions))
            return
        }
        setselecteddropoptions([])
    }, [lookupModalContext, designationOptions, departmentOptions, categoryOptions, groupOptions])

    // render template for dropdown items so sentinel rows show icons
    const dropdownItemTemplate = (option) => {
        if (!option) return null
        // handle sentinel shapes { value: 'add'|'edit', label: 'Add New'|'Edit Selected' }
        if (option.value === 'add' || option.value === 'edit' || option.label === 'Add New' || option.label === 'Edit Selected') {
            const isAdd = option.value === 'add' || option.label === 'Add New'
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <i className={isAdd ? 'pi pi-plus' : 'pi pi-pencil'} style={{ fontSize: '1rem' }} />
                    <span>{option.label || option.name || option.value}</span>
                </div>
            )
        }
        // default rendering
        return <div>{option.label ?? option.name ?? option.value}</div>
    }
    // const companyOptions = [
    //     { name: 'Varun Digital Media', code: 'VDM' },
    //     { name: 'Pranathi Software Services', code: 'PSS' },
    //     { name: 'Green Ventures pvt Ltd', code: 'GV' },
    //     { name: 'Future Tech Solutions', code: 'FTS' },
    //     { name: 'Healthify Solutions pvt Ltd', code: 'MS' },

    // ];


    // const departmentOptions = [
    //     { name: 'Account Finance Team', code: 'HR' },
    //     { name: 'SPG US Staffing', code: 'FIN' },
    //     { name: 'Vitel Development Team', code: 'MKT' },
    //     { name: 'Support Team', code: 'ENG' },
    //     { name: 'NOC Team', code: 'SAL' },
    //     { name: 'Digital Marketing Team', code: 'DIG' },
    //     { name: 'Executive Team', code: 'EXE' },
    //     { name: 'Operations Team', code: 'OPE' }
    // ];



    // const personOptions = [
    //     { name: 'Salmanuddin Syed', role: 'Operation Head', code: 'OH' },
    //     { name: 'Girish Bodepu', role: 'Manager', code: 'MGR' },
    //     { name: 'Suresh Reddy', role: 'Team Lead', code: 'TL' },
    //     { name: 'Ravi Kumar', role: 'Team Lead', code: 'TL' },
    //     { name: 'Neha Patel', role: 'Team Lead', code: 'TL' }
    // ];



    // const categoryOptions = [
    //     { label: "Micro Enterprise", value: "micro" },
    //     { label: "Small Enterprise", value: "small" },
    //     { label: "Medium Enterprise", value: "medium" },
    //     { label: "Large Enterprise", value: "large" },
    // ];



    // const groupOptions = [
    //     { label: "Up to 5 Crore", value: "5cr" },
    //     { label: "Up to 50 Crore", value: "50cr" },
    //     { label: "Up to 250 Crore", value: "250cr" },
    //     { label: "Above 250 Crore", value: "above250cr" },
    // ];

    const [userid1, setUserid1] = useState("Harish");

    // Private functionality state



    // const PrivetDropdownValues = [
    //     { name: 'Mahesh', value: 'mahesh' },
    //     { name: 'Lavan', value: 'lavan' },
    //     { name: 'Vinay', value: 'vinay' },
    //     { name: 'Vasantha', value: 'vasantha' }
    // ];
     const [reportingFile, setReportingFile] = useState(null)
     const handleFileUploadChange = (e) => {
    const f = e.target.files && e.target.files[0]
    setReportingFile(f)
  }
    const onUpload = (event) => {

        toast.current.show({ severity: 'info', summary: 'Success', detail: `${event.files.length} file(s) uploaded` });
    };

    const labels = [
        { name: "Work from Office (WFO)", code: "WORK" },
        { name: "Work from Home (WFH)", code: "HOME" },
        { name: "Work from Remote (WFR)", code: "REMOTE" }
    ]

    const [visible, setVisible] = useState(false)
    const [street1, setStreet1] = useState("White house, Block - III")
    const [street2, setStreet2] = useState("Begumpet")
    const [selectedCity, setSelectedCity] = useState("Hyderabad")
    const addCities = [
        { name: 'Hyderabad', code: 'HYD' },
        { name: 'Chennai', code: 'CHN' },
        { name: 'Mumbai', code: 'MUM' },
        { name: 'Bangalore', code: 'BLR' },
        { name: 'Delhi', code: 'DEL' },
    ]
    const [selectedState, setSelectedState] = useState("Telangana")
    const addStates = [
        { name: 'Andhra Pradesh', code: 'AP' },
        { name: 'Telangana', code: 'TG' },
        { name: 'Tamil Nadu', code: 'TN' },
        { name: 'Karnataka', code: 'KA' },
        { name: 'Kerala', code: 'KL' },
    ]
    const [selectedCountry, setSelectedCountry] = useState("")
    const addCountries = [
        { name: "India", code: "IN" },
        { name: "United States", code: "US" },
        { name: "Canada", code: "CA" },
        { name: "Germany", code: "DE" },
        { name: "Australia", code: "AU" },
    ]

    const [postalCode, setPostalCode] = useState("")
    const [selectedLabel, setSelectedLabel] = useState(null)

    const [address, setAddress] = useState("")

    const updateAddress = () => {
        // setAddress(`${street1}  ${street2} ${postalCode}`.trim());
    }
    useEffect(() => {
        const updatedAddress = [
            street1,
            street2,
            selectedCity,
            selectedState,
            selectedCountry,
            postalCode,
            selectedLabel?.name,
        ].filter(Boolean)
        setAddress(updatedAddress?.join("\n"))
    }, [
        street1,
        street2,
        postalCode,
        selectedState,
        selectedCity,
        selectedCountry,
        selectedLabel,
    ])




    // company edit form ends

    // toast msg

    const toast = useRef(null);

    const showMessage = () => {
        toast.current.show({ severity: 'info', summary: 'Job ID 3048 Saved' });
    };
    const showCancel = () => {
        toast.current.show({ severity: 'error', summary: 'Cancelled', life: 3000 });
    }
const handleSubmit = async (e) => {
        e.preventDefault();
        let privateUsersIds = PrivetDropdownValues ? PrivetDropdownValues.map(user => user.value) : [];
        try {
            const formData = {
                fullname: fullname,
                email: email,
                phone: phno,
                designation: selectedDesignation1,
                company: selectedCompany,
                designation_type: selectedDesignation1,
                department: selectedDepartment,
                reporting_to: selectedPerson,
                category: selectedCategory1?.label,
                group: selectedGroup1?.label,
                is_private: privateDrop,
                private_users: privateUsersIds,
                address: Array.isArray(address) ? address.join(', ') : address,
                
            };
            const response = await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/contacts/${id}/`, formData, {
          headers: {
          Authorization: `Bearer ${Token}`,
        },
            });

            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Contact updated successfully',
                    life: 3000
                });
                navigate('/contacts-allactive')
            }
        } catch (error) {
            console.error('Error updating contact:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.message || 'Failed to update contact',
                life: 3000
            });
        }
    }
    const [documentTypes, setdocumentTypes] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
 const getDocuments = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/contacts/${id}/documents/`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            })
            if (response.status === 200) {
                setDocuments(response.data.data);
                console.log(response.data.data, 'documents');
            }
        } catch (err) {
            console.log(err);

        }
    }
    const getDoctType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            })
            if (response.status === 200) {
                const options = response.data.results.results.map((category) => ({
                    name: category.value
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    code: category.id,
                }));
                setdocumentTypes(options);
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        getDoctType();
        getDocuments()
    }, []);
    const handleAddDocument = async () => {
        try {
            const formData = new FormData();
            formData.append('type', selectedDocument || '');
            formData.append('description', subject || '');
            if (uploadedFiles instanceof File) {
                formData.append('uploaded_files', uploadedFiles);
            }
            else if (Array.isArray(uploadedFiles)) {
                uploadedFiles.forEach((file, idx) => {
                    formData.append('uploaded_files', file);
                });
            }

            const response = await axios.post(
                `${process.env.REACT_APP_Company_Contact}/company/contacts/${id}/documents/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${Token}`,
                    }
                }
            );


            if (response.status === 201) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Document added successfully', life: 3000 });
                // setDocuments(prev => [...prev, response.data]);
                setDisplayDialog(false);
                setSelectedDocument(null);
                setSubject('');
                setUploadedFiles(null);
                getData();
                getDocuments();
                // setFile(null);
            }
        } catch (error) {
            console.error('Error adding document:', error);
        }
    };
    const [FileNames,setFileNames] = useState([]);
        const [isEdit,setIsEdit]= useState(false);
        const [selectedDocId,setSelectedDocId]= useState(null);
        const handleEdit = (doc) => {
            console.log('Editing document:', doc);
            setDisplayDialog(true);
            setSelectedDocId(doc.id);
            setIsEdit(true);
            setSubject(doc.description);
            setSelectedDocument(doc.type || null);
            const LastFiles = Array.isArray(doc.files)
                ? doc.files.map((fileItem, index) => ({
                    id: `${doc.id}-${index}`,
                    selectedId: fileItem.id,
                    name: fileItem.original_filename,
                    url: fileItem.file, 
                }))
                : doc.files
                    ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
                    : [];
    
            setFileNames(LastFiles);
        };
        
        const handleDelete = async (rowKey) => {
            console.log('Deleting document with key:', rowKey);
            
            try {
                const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/companies/${id}/documents/${rowKey}/`, {
                    headers: {
                        Authorization: `Bearer ${Token}`,
                    },
                });
                if (response.status === 200) {
                    getDocuments()
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
                }
            } catch (err) {
                console.log(err);
    
            }
        }
        const handleUpdateDocument = async () => {
        if (!selectedDocument || !subject) {
            alert('Please fill all the fields.');
            return;
        }
    
        try {
            const formData = new FormData();
    
            // Document type
            const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
            const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
            formData.append('type', selectedDocument);
            formData.append('description', subject);
    
            // Append newly uploaded files
            if (uploadedFiles && uploadedFiles.length > 0) {
                uploadedFiles.forEach((file) => {
                    formData.append('uploaded_files', file);
                });
            }
            if (FileNames && FileNames.length > 0) {
                FileNames.forEach((file) => {
                    formData.append('files_to_keep', file.selectedId);
                });
            }
    
            const response = await axios.patch(
                `${process.env.REACT_APP_Company_Contact}/company/companies/${id}/documents/${selectedDocId}/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${Token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            if (response.status == 200 || response.status == 201) {
            getDocuments();
            setDisplayDialog(false);
            setSelectedDocument(null);
            setSubject('');
            setFileNames([]);
            setUploadedFiles([]);
            setIsEdit(false);
            }
    
            toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });
    
        } catch (err) {
            console.error('Failed to update document', err);
            alert('Failed to update document');
        }
    };
    return (
        <React.Fragment>
            <div className="page-content create-ajob">
                <Container fluid>
                     <Toast ref={toast} />
                    <form onSubmit={handleSubmit}>
                    <div className="page-title-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <h1 className="page-title">Edit a Contact</h1>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item active">
                                        Edit a contact with essential details, including basic information and contact details, to maintain accurate records and facilitate communication.
                                    </li>
                                </ol>
                            </Col>
                            {/* <Col md={6}>
                                <div className="d-flex justify-content-end">
                                    <Toast ref={toast} />
                                        <button type="submit" class="btn btn-success me-2" onSubmit={handleSubmit}>  <i className="pi pi-save me-1"></i> Save </button>
                                    <Link to="/contacts-allactive">
                                        <Button
                                            color="primary"
                                            className="btn btn-primary me-2 cancel-outlinebtn"
                                        >
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                        </Button>
                                    </Link>
                                </div>
                            </Col> */}
                        </Row>
                    </div>

                    <Row>
                        {/* 1st Row */}
                        <Col xl={6}>
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Basic Information</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div className="">

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="fullname">Full name</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText 
                                                            id="fullname" 
                                                            value={fullname} 
                                                            onChange={(e) => setFullname(e.target.value)}
                                                            className="w-full" 
                                                            placeholder="Enter full name"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="email">Email</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="p-field mb-0">
                                                            <InputText
                                                                id="email"
                                                                className="w-full"
                                                                value={email}
                                                                onChange={(e) => {
                                                                    const emailValue = e.target.value;
                                                                    setEmail(emailValue);
                                                                }}
                                                                placeholder="Enter email address"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="currentSalary" className="block mb-2">
                                                            Phone Number
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="phone"
                                                            className="w-full"
                                                            value={phno}
                                                            onChange={(e) => {
                                                                const phoneValue = e.target.value;
                                                                // Only allow numbers and basic phone formatting characters
                                                                if (/^[0-9\-\+\(\)\s]*$/.test(phoneValue)) {
                                                                    setPhno(phoneValue);
                                                                }
                                                            }}
                                                            placeholder="Enter phone number"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="designation" className="block mb-2">
                                                            Designation
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>

                                                        <Dropdown
                                                            id="category"
                                                            value={selectedDesignation1}
                                                            onChange={(e) => {
                                                                const v = e.value
                                                                if (v && (v.value === 'add' || v === 'add')) {
                                                                    setLookupModalContext('designation')
                                                                    setEditingLookup(false)
                                                                    setLookupFormValue('')
                                                                    setLookupDescription('')
                                                                    setLookupModalVisible(true)
                                                                    return
                                                                }
                                                                if (v && (v.value === 'edit' || v === 'edit')) {
                                                                    // open edit modal for current selection
                                                                    setLookupModalContext('designation')
                                                                    setEditingLookup(true)
                                                                    // If current selection has an id, set for patch
                                                                    setLastSelectedLookupId(selectedDesignation1)
                                                                    setLookupFormValue(getOptionLabel(designationOptions, selectedDesignation1))
                                                                    setLookupModalVisible(true)
                                                                    return
                                                                }
                                                                setSelectedDesignation1(v)
                                                            }}
                                                            options={designationOptions}
                                                            itemTemplate={dropdownItemTemplate}
                                                            placeholder="Large Enterprise"
                                                            className="w-full bgclr"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="company">Company</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="card mb-0 border-0">
                                                            <Dropdown
                                                                value={selectedCompany}
                                                                onChange={(e) => setSelectedCompany(e.value)}
                                                                options={companyOptions}
                                                                optionLabel="name"
                                                                optionValue="code"
                                                                placeholder="Select Company"
                                                                filter
                                                                className="w-full bgclr"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="company">Department</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="card mb-0 border-0">
                                                            <Dropdown
                                                                value={selectedDepartment}
                                                                onChange={(e) => {
                                                                    const v = e.value
                                                                    if (v && (v.value === 'add' || v === 'add')) {
                                                                        setLookupModalContext('department')
                                                                        setEditingLookup(false)
                                                                        setLookupFormValue('')
                                                                        setLookupDescription('')
                                                                        setLookupModalVisible(true)
                                                                        return
                                                                    }
                                                                    if (v && (v.value === 'edit' || v === 'edit')) {
                                                                        setLookupModalContext('department')
                                                                        setEditingLookup(true)
                                                                        setLastSelectedLookupId(selectedDepartment)
                                                                        setLookupFormValue(getOptionLabel(departmentOptions, selectedDepartment))
                                                                        setLookupModalVisible(true)
                                                                        return
                                                                    }
                                                                    setSelectedDepartment(v)
                                                                }}
                                                                   options={departmentOptions}
                                                                   itemTemplate={dropdownItemTemplate}
                                                                optionLabel="name"
                                                                optionValue="code"
                                                                placeholder="Select Department"
                                                                filter
                                                                className="w-full bgclr"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>


                                    </Row>
                                </CardBody>
                            </Card>


                            <Col xl={12}>
                                <Card className="bg-form">
                                    <CardBody>
                                        <h4 className="card-title mb-2">System Fields</h4>
                                        <Row>
                                            <Col xl={12}>
                                                <div className="">
                                                    <Row>
                                                        <Col xl={12}>
                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label

                                                                        className=" block"
                                                                    >
                                                                        Create Date
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="createDate"
                                                                        placeholder="27/02/2025"
                                                                        className="w-full"
                                                                        disabled
                                                                        value={CreatedAt}
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label

                                                                        className=" block"
                                                                    >
                                                                        Edit Date
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <Calendar
                                                                        id="editDate"
                                                                        disabled
                                                                        value={UpdatedAt}
                                                                        className="w-full"
                                                                        placeholder="27/02/2025"
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label

                                                                        className=" block"
                                                                    >
                                                                        Created By
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText
                                                                        id="integer"
                                                                        className="w-full"
                                                                        disabled
                                                                        value={createdBy}
                                                                    />
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2 align-items-center">
                                                                <Col xl={3}>
                                                                    <label

                                                                        className=" block"
                                                                    >
                                                                        Edited By
                                                                    </label>
                                                                </Col>
                                                                <Col xl={9}>
                                                                    <InputText
                                                                        id="integer"
                                                                        className="w-full"
                                                                        placeholder="Harish"
                                                                        disabled
                                                                        value={editedBy}
                                                                    />
                                                                </Col>
                                                            </Row>




                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Project Documents</h4>

                                    <Row>
                                        <Col xl={12}>
                                        <div className="d-flex justify-content-end mb-3 mt-1">
                                                    <Button
                                                        color="primary"
                                                        type="button"
                                                        onClick={() => setDisplayDialog(true)}
                                                    >
                                                        <i className="pi pi-plus me-1"></i> Add More
                                                    </Button>
                                                </div>
                                            <div>
                                                <DataTable
                                                    value={documents}
                                                    rows={5}
                                                    className="p-datatable-gridlines"
                                                    emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                                >
                                                    <Column
                                                        field="type_name"
                                                        header="Document Type"
                                                    />
                                                    <Column
                                                        field="description"
                                                        header="Subject"
                                                    />
                                                    <Column
                                                        field="created_at"
                                                        header="Uploaded On"
                                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                    />
                                                    <Column
                                                        header="Attachments"
                                                        body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                                            <ul className="list-unstyled mb-0">
                                                                {rowData.files.map((fileItem) => (
                                                                    <li key={fileItem.id}>
                                                                        <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                                            {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        ) : 'No file'}
                                                    />
                                                    <Column
                                                        header="Actions"
                                                        body={(rowData) => (
                                                            <div className="d-flex gap-2">
                                                                <Button
                                                                    type="button"
                                                                    icon="pi pi-pencil"
                                                                    className="p-button-rounded p-button-text p-button-info"
                                                                    tooltip="Edit"
                                                                    onClick={() => handleEdit(rowData)}
                                                                />
                                                                <Button
                                                                    icon="pi pi-trash"
                                                                    className="p-button-rounded p-button-text p-button-danger"
                                                                    tooltip="Delete"
                                                                    type="button"
                                                                    onClick={() => handleDelete(rowData.id)}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>

                                                {/* Button in next row, aligned right */}
                                                
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>


                        {/* 2nd Row */}

                        <Col xl={6}>
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Contact Details</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div className="">

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="company">Reporting Person</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <div className="card mb-0 border-0">
                                                            <Dropdown
                                                                value={selectedPerson}
                                                                options={personOptions}
                                                                onChange={(e) => setSelectedPerson(e.value)}
                                                                optionLabel={(option) => `${option.name}`}
                                                                placeholder="Select Reporting Person"
                                                                className="bgclr"
                                                                optionValue="code"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="currentSalary" className="block mb-2">
                                                            Categories
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="category"
                                                            value={selectedCategory1}
                                                            onChange={(e) => {
                                                                const v = e.value
                                                                if (v && (v.value === 'add' || v === 'add')) {
                                                                    setLookupModalContext('category')
                                                                    setEditingLookup(false)
                                                                    setLookupFormValue('')
                                                                    setLookupDescription('')
                                                                    setLookupModalVisible(true)
                                                                    return
                                                                }
                                                                if (v && (v.value === 'edit' || v === 'edit')) {
                                                                    setLookupModalContext('category')
                                                                    setEditingLookup(true)
                                                                    setLastSelectedLookupId(selectedCategory1)
                                                                    setLookupFormValue(getOptionLabel(categoryOptions, selectedCategory1))
                                                                    setLookupModalVisible(true)
                                                                    return
                                                                }
                                                                setSelectedCategory1(v)
                                                            }}
                                                                options={categoryOptions}
                                                                itemTemplate={dropdownItemTemplate}
                                                            placeholder="Large Enterprise"
                                                            className="w-full bgclr"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="yearFounded" className="block mb-2">
                                                            Groups
                                                        </label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="group"
                                                            value={selectedGroup1}
                                                            onChange={(e) => {
                                                                const v = e.value
                                                                if (v && (v.value === 'add' || v === 'add')) {
                                                                    setLookupModalContext('group')
                                                                    setEditingLookup(false)
                                                                    setLookupFormValue('')
                                                                    setLookupDescription('')
                                                                    setLookupModalVisible(true)
                                                                    return
                                                                }
                                                                if (v && (v.value === 'edit' || v === 'edit')) {
                                                                    setLookupModalContext('group')
                                                                    setEditingLookup(true)
                                                                    setLastSelectedLookupId(selectedGroup1)
                                                                    setLookupFormValue(getOptionLabel(groupOptions, selectedGroup1))
                                                                    setLookupModalVisible(true)
                                                                    return
                                                                }
                                                                setSelectedGroup1(v)
                                                            }}
                                                               options={groupOptions}
                                                               itemTemplate={dropdownItemTemplate}
                                                            placeholder="Above 250 Crore"
                                                            className="w-full bgclr"
                                                        />
                                                    </Col>
                                                </Row>




                                                <Row className="mt-2 align-items-center mb-2">
                                                    <Col xl={3}>
                                                        <label htmlFor="attachment">Attach Document</label>
                                                    </Col>
                                                        <Col xl={9}>
                                                            <div>
                                                                <DataTable
                                                                    value={documents}
                                                                    rows={5}
                                                                    className="p-datatable-gridlines"
                                                                    emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                                                >
                                                                    <Column
                                                                        field="description"
                                                                        header="Subject"
                                                                    />
                                                                    <Column
                                                                        field="created_at"
                                                                        header="Uploaded On"
                                                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                                    />
                                                                    <Column
                                                                        header="Attachment"
                                                                        body={(rowData) => rowData.file ? (
                                                                            <a href={rowData.file} target="_blank" rel="noopener noreferrer">
                                                                                View File
                                                                            </a>
                                                                        ) : 'No file'}
                                                                    />
                                                                </DataTable>

                                                                <div className="block d-flex justify-content-end align-items-center">
                                                                    <a
                                                                        color="primary"
                                                                        className="anchr-title mt-3"
                                                                        onClick={() => setDisplayDialog(true)}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <i className="pi pi-plus me-1"></i> Add More
                                                                    </a>
                                                                </div>
                                                            </div>

                                                        </Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col lg={3}>
                                                        <label htmlFor="address">Address</label>
                                                    </Col>
                                                    <Col lg={9}>
                                                        <div
                                                            className="p-field companie-add"
                                                            style={{ position: "relative" }}
                                                        >
                                                            <InputTextarea
                                                                id="address"
                                                                value={address}
                                                                onChange={e => setAddress(e.target.value)}
                                                                placeholder="Enter your address"
                                                                style={{ paddingRight: "2rem" }} // Optional styling
                                                                rows={8} // Specify number of rows
                                                                cols={30} // Specify width
                                                                className="w-full"
                                                                readOnly
                                                            />
                                                            {/* Edit Icon */}
                                                            <i
                                                                className="pi pi-pencil"
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "10px",
                                                                    top: "70%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#6c757d",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => setVisible(true)}
                                                            ></i>
                                                        </div>
                                                    </Col>



                                                    <Dialog
                                                        header="Edit Address"
                                                        className="address-popup"
                                                        visible={visible}
                                                        onHide={() => {
                                                            if (!visible) return
                                                            setVisible(false)
                                                        }}
                                                        style={{ width: "30vw" }}
                                                        breakpoints={{
                                                            "960px": "75vw",
                                                            "641px": "100vw",
                                                        }}
                                                    >
                                                        <div className="card sidebardetails">
                                                            <form>
                                                                <Row className="mb-3">
                                                                    <Col lg={6}>
                                                                        <div className="p-field">
                                                                            <label htmlFor="street1">
                                                                                Street 1
                                                                            </label>
                                                                            <InputText
                                                                                id="street1"
                                                                                value={street1}
                                                                                onChange={e => {
                                                                                    setStreet1(e.target.value)
                                                                                    updateAddress()
                                                                                }}
                                                                                placeholder=""
                                                                                className="w-full activejobdrop"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <label htmlFor="street2">Street 2</label>
                                                                        <InputText
                                                                            id="street2"
                                                                            value={street2}
                                                                            onChange={e => {
                                                                                setStreet2(e.target.value)
                                                                                updateAddress()
                                                                            }}
                                                                            placeholder="Enter Street 2 (Optional)"
                                                                            className="w-full activejobdrop"
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col lg={6}>
                                                                        <label htmlFor="city">City</label>
                                                                        <Dropdown
                                                                            id="city"
                                                                            value={selectedCity}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedCity(e.value.name)
                                                                            }}
                                                                            options={addCities}
                                                                            optionLabel="name"
                                                                            filter
                                                                            filterPlaceholder="Search City"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="Hyderabad"
                                                                        />
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <label htmlFor="state">State</label>
                                                                        <Dropdown
                                                                            id="state"
                                                                            value={selectedState}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedState(e.value.name)
                                                                            }}
                                                                            options={addStates}
                                                                            optionLabel="name"
                                                                            filter
                                                                            filterPlaceholder="Search State"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="Telangana"
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col lg={6}>
                                                                        <label htmlFor="country">Country</label>
                                                                        <Dropdown
                                                                            id="country"
                                                                            value={selectedCountry}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedCountry(e.value.name)
                                                                            }}
                                                                            options={addCountries}
                                                                            optionLabel="name"
                                                                            filter
                                                                            filterPlaceholder="Search Country"
                                                                            className="w-full activejobdrop"
                                                                            placeholder="India"
                                                                        />
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <label htmlFor="postalCode">
                                                                            Postal Code
                                                                        </label>
                                                                        <InputText
                                                                            id="postalCode"
                                                                            value={postalCode}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setPostalCode(e.target.value)
                                                                            }}
                                                                            placeholder=""
                                                                            className="w-full activejobdrop"
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row className="mb-3">
                                                                    <Col lg={12}>
                                                                        <label htmlFor="postalCode">Label</label>
                                                                        <Dropdown
                                                                            value={selectedLabel}
                                                                            onChange={e => {
                                                                                updateAddress()
                                                                                setSelectedLabel(e.value)
                                                                            }}
                                                                            options={labels}
                                                                            optionLabel="name"
                                                                            placeholder="Work From Office"
                                                                            className="w-full activejobdrop"
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </form>
        
                                                                    <Row>
                                                                        <Col>
                                                                            <Button
                                                                                type="button"
                                                                                color="primary"
                                                                                className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                                                                                onClick={() => { setVisible(false); }}
                                                                            >
                                                                                <i className="pi pi-check me-1"></i> Save
                                                                            </Button>

                                                                            <Button
                                                                                type="button"
                                                                                color="primary"
                                                                                className="btn btn-primary waves-effect waves-light cancelbtn me-2"
                                                                                onClick={() => {
                                                                                    setVisible(false);
                                                                                    setStreet1('');
                                                                                    setStreet2('');
                                                                                    setSelectedCity(null);
                                                                                    setSelectedState(null);
                                                                                    setSelectedCountry(null);
                                                                                    setPostalCode('');
                                                                                    setSelectedLabel(null);
                                                                                    setAddress('');
                                                                                }}
                                                                            >
                                                                                <i className="pi pi-times me-1"></i>
                                                                                Cancel
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>                                                </div>
                                                    </Dialog>


                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col lg={3}>
                                                        <label htmlFor="userids" className="block mb-2">
                                                            Private
                                                        </label>
                                                    </Col>
                                                    <Col lg={9}>
                                                        <Row className="align-items-center">
                                                            <Col lg={3}>
                                                                <div className="p-field d-flex align-items-center">
                                                                    <Checkbox
                                                                        inputId="privateCheckbox"
                                                                        checked={privateDrop}
                                                                        onChange={(e) => setPrivateDrop(e.checked)}
                                                                    />
                                                                    {/* <label htmlFor="privateCheckbox" className="ms-2">Private</label> */}
                                                                </div>
                                                            </Col>
                                                            <Col xl={9}>
                                                                {privateDrop && (
                                                                    <div className="p-field">
                                                                        <MultiSelect
                                                                            value={PrivetDropdown}
                                                                            onChange={(e) => setPrivetDropdown(e.value)}
                                                                            options={PrivetDropdownValues}
                                                                            // optionLabel="name"
                                                                            optionLabel={option => `${option.name} (${option.email})`}
                                                                            display="comma"
                                                                            placeholder="Select User Id's"
                                                                            maxSelectedLabels={3}
                                                                            className="w-full"
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row >

                    <Row>

                    </Row>


                    <Row className="align-items-center mb-3">
                        <Col md={12}>
                            {/* Lookup Add/Edit Dialog */}
                            <Dialog header={editingLookup ? 'Edit Lookup' : 'Add Lookup'} visible={lookupModalVisible} style={{ width: '30vw' }} onHide={() => { setLookupModalVisible(false); setEditingLookup(false); setLookupFormValue(''); setLookupDescription(''); setSelectedEditdrop(null); }}>
                                <div className="p-fluid">
                                    {editingLookup && (
                                        <>
                                            <label className="mb-1">Select item to edit</label>
                                            <Dropdown
                                                value={selectedEditdrop}
                                                options={selecteddropoptions}
                                                onChange={(e) => {
                                                    const selectedObj = selecteddropoptions.find((opt) => opt.id === e.value || opt.code === e.value)
                                                    setLookupFormValue(selectedObj ? (selectedObj.name || selectedObj.value || selectedObj.label) : '')
                                                    const resolvedId = selectedObj ? (selectedObj.id ?? selectedObj.code) : null
                                                    setSelectedEditdrop(resolvedId)
                                                    setLastSelectedLookupId(resolvedId)
                                                    setLookupDescription((selectedObj && (selectedObj.raw && (selectedObj.raw.description || selectedObj.raw.desc))) || '')
                                                }}
                                                placeholder="Select to prefill"
                                                className="w-full bgclr mb-2"
                                                optionLabel="name"
                                                optionValue="id"
                                                filter
                                            />
                                        </>
                                    )}
                                    <div className="p-field">
                                        <label>Value</label>
                                        <InputText value={lookupFormValue} onChange={e => setLookupFormValue(e.target.value)} />
                                    </div>
                                    <div className="p-field">
                                        <label>Description (optional)</label>
                                        <InputTextarea value={lookupDescription} onChange={e => setLookupDescription(e.target.value)} rows={3} />
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <Button label="Cancel" className="me-2" onClick={() => { setLookupModalVisible(false); setEditingLookup(false); setLookupFormValue(''); setLookupDescription(''); setSelectedEditdrop(null); }} />
                                        <Button label={editingLookup ? 'Update' : 'Add'} onClick={() => handleLookupSave()} />
                                    </div>
                                </div>
                            </Dialog>
                            <div className="d-flex justify-content-end">
                                    <button type="submit" className="btn btn-success me-2">
                        <i className="pi pi-save me-1"></i>Save
                    </button>

                                <Link to="/contacts-allactive">
                                    <Button
                                        color="primary"
                                        className="btn btn-primary me-2 cancel-outlinebtn"
                                    >
                                        <i className="pi pi-times me-1"></i>
                                        Cancel
                                    </Button>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                    </form>
                    <Dialog
                        header="Add Document"
                        visible={displayDialog}
                        onHide={() => { { setDisplayDialog(false); setSelectedDocument(null); setSubject(''); setUploadedFiles([]);setIsEdit(false);setFileNames([]) } }}
                        style={{ width: "30vw" }}
                        footer={
                            <div className="d-flex justify-content-end gap-2">
                                {isEdit ? <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                                    <i className="pi pi-pencil me-1"></i>
                                    Update
                                </Button> :
                                    <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                                        <i className="pi pi-plus me-1"></i>
                                        Add Document
                                    </Button>}
                                <Button color="btn btn-primary cancel-outlinebtn" onClick={() => { { setDisplayDialog(false); setSelectedDocument(null); setSubject(''); setUploadedFiles([]) } }}>
                                    <i className="pi pi-times me-1"></i>
                                    Cancel
                                </Button>
                            </div>
                        }
                    >
                        <Row className="mt-2 align-items-center">
                            <Col xl={3}>
                                <label htmlFor="type" className="block mb-2">
                                    Type
                                </label>
                            </Col>
                            <Col xl={9}>
                                <Dropdown
                                    id="project"
                                    value={selectedDocument}
                                    onChange={(e) => setSelectedDocument(e.value)}
                                    options={[
                                        ...documentTypes,
                                        { code: 'add', name: 'Add New', icon: 'pi pi-plus' },
                                        ...(selectedDocument ? [{ code: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                    ]}
                                    placeholder="Select Document Type"
                                    className="w-full bgclr"
                                    optionLabel="name"
                                    optionValue="code"
                                    filter
                                    itemTemplate={(option) => (
                                        <div className="flex align-items-center gap-2">
                                            {option?.icon && <i className={option.icon}></i>}
                                            <span>{option.name}</span>
                                        </div>
                                    )}
                                />
                            </Col>
                        </Row>

                        <Row className="mt-2 align-items-center">
                            <Col xl={3}>
                                <label htmlFor="subject" className="block mb-2">
                                    Description
                                </label>
                            </Col>
                            <Col xl={9}>
                                <InputText
                                    id="subject"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                    className="w-full"
                                    style={{ border: '1px solid #ced4da' }}
                                />
                            </Col>
                        </Row>

                        <Row className="mt-2 align-items-center">
                            <Col xl={3}>
                                <label htmlFor="attachment" className="block mb-2">
                                    Attachment
                                </label>
                            </Col>
                            <Col xl={9}>
                                <FileUpload
                                    ref={fileUploadRef}
                                    name="files[]"
                                    accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    maxFileSize={5242880}
                                    multiple
                                    customUpload
                                    auto={false}
                                    onSelect={(e) => {
                                        // Get current files (previously uploaded ones)
                                        const currentFiles = uploadedFiles || [];

                                        // Validate individual file types first for new files
                                        const allowedTypes = [
                                            'image/jpg', 'image/jpeg', 'image/png',
                                            'application/pdf',
                                            'application/msword', // .doc
                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                                            'text/plain', // .txt
                                            'application/vnd.ms-excel', // .xls
                                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
                                        ];

                                        const validNewFiles = e.files.filter(file => allowedTypes.includes(file.type));
                                        const invalidFiles = e.files.filter(file => !allowedTypes.includes(file.type));

                                        if (invalidFiles.length > 0) {
                                            toast.current?.show({
                                                severity: "error",
                                                summary: "Invalid File Type",
                                                detail: `File(s) rejected: ${invalidFiles.map(f => f.name).join(', ')}. Only Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`,
                                                life: 5000
                                            });

                                            // If there are valid files, continue with them; otherwise clear and return
                                            if (validNewFiles.length === 0) {
                                                // Clear the component and restore previous files
                                                setTimeout(() => {
                                                    if (fileUploadRef.current) {
                                                        fileUploadRef.current.clear();
                                                        // Restore previous files to the component
                                                        if (currentFiles.length > 0) {
                                                            fileUploadRef.current.setFiles(currentFiles);
                                                        }
                                                    }
                                                }, 0);
                                                return;
                                            }
                                        }

                                        // Combine current files with valid new files
                                        const allFiles = [...currentFiles, ...validNewFiles];

                                        // Calculate total size of all files (current + new valid files)
                                        const totalSize = allFiles.reduce((sum, file) => sum + file.size, 0);
                                        const maxTotalSize = 5242880; // 5MB total limit (5 * 1024 * 1024)
                                        const totalSizeMB = totalSize / (1024 * 1024);

                                        console.log(`File validation - Current files: ${currentFiles.length}, New files: ${validNewFiles.length}, Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB, Limit: ${(maxTotalSize / (1024 * 1024)).toFixed(1)}MB`);

                                        if (totalSize > maxTotalSize) {
                                            const currentSizeMB = currentFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
                                            const newSizeMB = validNewFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);

                                            toast.current?.show({
                                                severity: "error",
                                                summary: "File Size Error",
                                                detail: `Cannot add ${validNewFiles.length} file(s) (${newSizeMB.toFixed(2)}MB). Current files: ${currentSizeMB.toFixed(2)}MB, Total would be: ${totalSizeMB.toFixed(2)}MB. Maximum allowed: 5MB.`,
                                                life: 5000
                                            });

                                            // Clear the component and restore only previous files
                                            setTimeout(() => {
                                                if (fileUploadRef.current) {
                                                    fileUploadRef.current.clear();
                                                    // Restore only the previous files, not the new ones
                                                    if (currentFiles.length > 0) {
                                                        fileUploadRef.current.setFiles(currentFiles);
                                                    }
                                                }
                                            }, 0);
                                            return;
                                        }

                                        // Success - files are valid
                                        toast.current?.show({
                                            severity: "success",
                                            summary: "Files Added",
                                            detail: `${validNewFiles.length} file(s) added. Total: ${allFiles.length} files (${totalSizeMB.toFixed(2)}MB)`,
                                            life: 3000
                                        });

                                        setUploadedFiles(allFiles);
                                        console.log(`Upload ready - Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB`);
                                    }}
                                    uploadHandler={(e) => {
                                        // This will be called when files are manually uploaded
                                        console.log('Upload handler called', e.files);
                                    }}
                                    onClear={() => {
                                        console.log("Files cleared")
                                        setUploadedFiles([])
                                    }}
                                />
                                <small className="text-muted">
                                    Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                                </small>
                            </Col>
                            {FileNames && FileNames.length > 0 && (
                                                    <Row className="mt-2 align-items-center">
                                                        <Col xl={3}>
                                                            <label className="block mb-2">Previously Attached Files</label>
                                                        </Col>
                                                        <Col xl={9}>
                                                            {FileNames.map((file) => (
                                                                <div key={file.id} className="d-flex align-items-center mb-2">
                                                                    <a
                                                                        href={file.url || file.name} // use URL if available
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="me-2"
                                                                    >
                                                                        {file.name.split('/').pop()}
                                                                    </a>
                                                                    <i
                                                                        className="pi pi-times"
                                                                        style={{ cursor: "pointer", color: "red" }}
                                                                        onClick={() => {
                                                                            // Remove the clicked file from FileNames
                                                                            setFileNames(prev => prev.filter(f => f.id !== file.id));
                                                                        }}
                                                                    ></i>
                                                                </div>
                                                            ))}
                                                        </Col>
                            
                                                    </Row>
                                                )}
                        </Row>
                    </Dialog>
                </Container >
            </div >
        </React.Fragment >
    )

    
}

export default ContactEditForm;
